export default __webpack_public_path__ + "static/media/fire-engr.fcdfcd59.jpg";